import { createTheme } from '@mui/material/styles';
import { responsiveFontSizes } from "@mui/material/styles";

export const getTheme = (mode) => {
  return responsiveFontSizes(
    createTheme({
      palette: {
        mode,
        primary: {
          main: '#35bcc1',
          light: '#35bcc1',
          dark: '#35bcc1',
          contrastText: '#ffffff',
        },
        
        background: {
          default: mode === 'light' ? '#ededed' : '#0e1f1d',
          paper: mode === 'light' ? '#ffffff' : '#182c26',
        },
      },
      typography: {
        fontSize: 13,
        subtitle1: {
          fontWeight: 'bold',
        },
      },
      components: {
        MuiDialog: {
          styleOverrides: {
            paper: {
              backgroundColor: '#182c26',
              color: '#fff',
              backgroundImage: 'none',
            },
          },
        },
      },
    })
  )
}
